import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import MaintenanceIcon from "../../assets/icons/ui/maintenance.svg?react";
import styles from "./Maintenance.module.scss";

export const Maintenance = (props: Omit<MaintenancePageProps, "enabled">) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "Maintenance");

  return (
    <div className={block}>
      <MaintenanceIcon className={cn("icon")} />
      <h2
        className={cn("title")}
        dangerouslySetInnerHTML={{
          __html: props.title ?? t("maintenanceTitle"),
        }}
      />
      <span
        className={cn("subtitle")}
        dangerouslySetInnerHTML={{
          __html: props.subtitle ?? t("maintenanceSubtitle"),
        }}
      />
    </div>
  );
};

export interface MaintenanceConfigProps {
  timedMaintenanceModeStartTime: string;
  timedMaintenanceModeEndTime: string;
  timedMaintenanceModeEnabled: string;
  preAuthMaintenanceModeEnabled: string;
  maintenanceTitle: string;
  maintenanceSubtitle: string;
}

export interface MaintenancePageProps {
  enabled: boolean;
  title?: string;
  subtitle?: string;
}

export const getMaintenanceProps = (
  config: MaintenanceConfigProps
): MaintenancePageProps => {
  const startTime = config.timedMaintenanceModeStartTime
    ? parseInt(config.timedMaintenanceModeStartTime)
    : undefined;
  const endTime = config.timedMaintenanceModeEndTime
    ? parseInt(config.timedMaintenanceModeEndTime)
    : undefined;
  if (config.timedMaintenanceModeEnabled === "true" && startTime && endTime) {
    const currentTime = Date.now();
    return {
      enabled: currentTime <= endTime && currentTime >= startTime,
      title: config.maintenanceTitle,
      subtitle: config.maintenanceSubtitle,
    };
  }
  return {
    enabled: config.preAuthMaintenanceModeEnabled === "true",
    title: config.maintenanceTitle !== "" ? config.maintenanceTitle : undefined,
    subtitle:
      config.maintenanceSubtitle !== ""
        ? config.maintenanceSubtitle
        : undefined,
  };
};

export default Maintenance;
